import React from "react";
import { Form, Row, Col } from "antd";
import UniDropAdv from "../../components/ReportFormGenerator/UniDrop/UniDropAdv";
import StablePrime from "../../components/Tables/StablePrime";

function LineDash4MReport({ lid }) {
  const [form] = Form.useForm();

  const [typ, setTyp] = React.useState(null);

  const Changed = (value) => {
    
    setTyp(form.getFieldsValue());
  };

  const Table = () => {
    return (
      <div style={{ marginTop: "0px" }}>
        <StablePrime
          url="/linedash/tabs/fourmreport"
          data={{ ...typ, lid: lid, limit: 10 }}
          identity=""
        />
      </div>
    );
  };

  return (
    <div className="AuditSection CreateAudit" style={{ marginTop: "-5px" }}>
      <div className="ThemeForm">
        <Form
          name="ReportForm"
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          layout="horizontal"
          colon={false}
          size="large"
        >
          <Row justify="center">
            <Col span={12}>
              <UniDropAdv
                form={form}
                colSpan={24}
                multiSelect={false}
                url={"/cropdown"}
                disabled={false}
                source={"cropdown"}
                urlData={{ name: "CIHOX" }}
                pname={"typ_name"}
                name={"typ"}
                label={"Types"}
                errorMessage={"Please Select Status !"}
                required={true}
                placeholder={"Select Status"}
                defaultValue={null}
                searchable={true}
                includeAll={false}
                onChange={Changed}
              />
            </Col>
          </Row>
        </Form>
        {!typ ? (
          <></>
        ) : (
          <>
            <Table />
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(LineDash4MReport);
